import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Projectcolors from "../Utils/Colors";
import { baseURL } from "../Config/config";
import { Typography, Link } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import OutlinedInput from "@mui/material/OutlinedInput";
import Paper from "@mui/material/Paper";
import model from "../images/model.png";
import Arrow from "../images/arrow.png";
import Excel from "../images/excel.jpeg";
import { makeStyles } from "@mui/styles";
import GlobalLoader from "./CommonC/GlobalLoader";
import LinearProgress from "@mui/material/LinearProgress";
import PropTypes from "prop-types";
import axios from "axios";
import Plot from "react-plotly.js";
import { Checkbox, FormControlLabel } from '@mui/material';


function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          sx={{ fontSize: 14 }}
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

const useStyles = makeStyles({
  button: {
    textTransform: "none",
  },
});

function SelexOnline(props) {
  const [data, setData] = useState({
    independent: [],
    value: [],
    dependent: [],
  });
  const [isLoading, setIsLoading] = React.useState(false);
  const [errormessage, seterrormessage] = React.useState(
    "Something went wrong"
  );
  const [errmessage, seterrmessage] = React.useState(false);
  const [timestamps, setTimestamps] = useState([
   
  ]);
  const [getLoader, setGetLoader] = React.useState(false);
  //const [yAxisData, setYAxisData] = useState({}); // Stores nested Y-axis values
  const [yAxisData, setYAxisData] = useState({});
  const [labels, setLabels] = useState([]);
  const [visibleAxes, setVisibleAxes] = useState([]);
  const [startTimestamp, setStartTimestamp] = useState(timestamps[0]);
  const [saved, setSaved] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [endTimestamp, setEndTimestamp] = useState(
    timestamps[timestamps.length - 1]
  );
  const [connectionClose, setConnectionClose] = useState(true);
  React.useEffect(() => {
      getselexonlineData();
    }, []);

     const getselexonlineData = () => {
        setGetLoader(true);
        const projectID = sessionStorage.getItem("projectID");
        fetch(
          `${baseURL}/getselexonlinedata?projectID=${projectID}`
        )
          .then((res) => res.json())
          .then((data) => {
            setSaved(false);
            setRefresh(false);
            setData(data.newdata)
            setConnectionClose(data.isClose)
            const joinedArray = data.newdata.independent.concat(data.newdata.dependent);
            setLabels(joinedArray);
            setVisibleAxes(Array(joinedArray.length).fill(true));
            if (Object.keys(data.yAxisData).length === 0){
                const newData = {}
                joinedArray.forEach((key) => {
                    newData[key] = [];
                  });
                  setYAxisData(newData);
                  
            }
            else{
                setYAxisData(data.yAxisData);
                setTimestamps(data.timestamps);
                setStartTimestamp(data.timestamps[0])
                setEndTimestamp(data.timestamps[(data.timestamps.length-1)])
            }
    
    
              setGetLoader(false);

          })
          .catch((err) => {
            setGetLoader(false);
            console.log(err);
          });
      };
      
  
  useEffect(() => {
    let interval;
    const fetchData = () => {
      fetch(`${baseURL}/streamdata?projectID=${ProjectID}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.error == 1) {
            setData({ independent: [], value: [], dependent: [] });
            setSaved(false);
            setRefresh(false);
          } else {
            setSaved(false);
            setRefresh(false);
            setData(data)
            setConnectionClose(data.isClose);
            // Update timestamps
            setTimestamps((prev) => 
                {
                    const newTimestamps = [...prev, data.value[0]];
                    return newTimestamps; // Return the updated array

                });
            setStartTimestamp(timestamps[0]);
            setEndTimestamp(data.value[0])
            
  
            // Update yAxisData
            setYAxisData((prevData) => {
              const newData = { ...prevData }; // Shallow copy of the previous state
  
              // Initialize if empty
              if (Object.keys(newData).length === 0) {
                data.independent.forEach((key) => {
                  newData[key] = [];
                });
                data.dependent.forEach((key) => {
                  newData[key] = [];
                });
              }
  
              // Append new values
              data.independent.forEach((key, index) => {
                newData[key] = [...(newData[key] || []), data.value[index + 1]]; // Ensure immutability
              });
              data.dependent.forEach((key, index) => {
                newData[key] = [
                  ...(newData[key] || []),
                  data.value[data.independent.length + 1 + index],
                ];
              });
              

              return newData; // Return updated object
            });

  
            // Update labels and visibility
            const joinedArray = data.independent.concat(data.dependent);
            setLabels(joinedArray);
            setVisibleAxes(Array(joinedArray.length).fill(true));
          }
        })
        .catch((error) => console.error("Error fetching data:", error));
    };
    
    if(connectionClose == false){
    interval = setInterval(fetchData, 1000);
    } // Fetch every second

  
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [connectionClose]);
     

  const handleStartChange = (e) => {
    setStartTimestamp(e.target.value);
  };

  const handleEndChange = (e) => {
    setEndTimestamp(e.target.value);
  };

  const handleSave = () => {
    try {
      const projectID = sessionStorage.getItem("projectID");
      
       const body = JSON.stringify({
        projectID,
        data,
        timestamps,
        yAxisData,
      });
      const config = {
       
        headers: {
          "Content-Type": "application/json",
        },
      };
    
      setGetLoader(true);
      
      axios
        .post(`${baseURL}/saveselexonlinedata`, body,config)
       
        .then((result) => {
          if (result.data.message == 1){
            setSaved(true);
            setGetLoader(false);
            
          }
          else{
            setGetLoader(false);
          }
        })
        .catch((error) => {
          setGetLoader(false);
          console.error("Error:", error);
        });
    } catch (error) {
      setGetLoader(false);
      console.log("error", error);
    }
  };


  const handleRefresh = () => {
    try {
      const projectID = sessionStorage.getItem("projectID");
      
       const body = JSON.stringify({
        projectID,
        
      });
      const config = {
       
        headers: {
          "Content-Type": "application/json",
        },
      };
    
      setGetLoader(true);
      
      axios
        .post(`${baseURL}/refreshselexonlinedata`, body,config)
       
        .then((result) => {
          if (result.data.message == 1){
            setRefresh(true);
            setSaved(false);

            
            setData({independent:result.data.dataa.independent,value: [],dependent:result.data.dataa.dependent});
            const joinedArray = result.data.dataa.independent.concat(result.data.dataa.dependent);
            setLabels(joinedArray);
            setVisibleAxes(Array(joinedArray.length).fill(true));
            if (Object.keys(result.data.yAxisData).length === 0){
              const newData = {}
              joinedArray.forEach((key) => {
                  newData[key] = [];
                });
                setYAxisData(newData);
                
                
          }
          setTimestamps(result.data.timestamps);
          setStartTimestamp("");
          setEndTimestamp("");
          setGetLoader(false);





            
            
          }
          else{
            setGetLoader(false);
          }
        })
        .catch((error) => {
          setGetLoader(false);
          console.error("Error:", error);
        });
    } catch (error) {
      setGetLoader(false);
      console.log("error", error);
    }
  };

  // Filter timestamps and corresponding data based on selected range
  const filteredTimestamps = timestamps.filter(
    (t) => t >= startTimestamp && t <= endTimestamp
  );

  const handleCheckboxChange = (key, i) => {
    let copyaxes = [...visibleAxes];
    copyaxes[i] = !copyaxes[i];
    setVisibleAxes(copyaxes);
    
  };
  const yAxisKeys = Object.keys(yAxisData);
  let filteredData;
  filteredData = yAxisKeys
    .filter((_, index) => visibleAxes[index]) // Include only visible axes
    .map((key, index) => ({
      x: filteredTimestamps.length>0?filteredTimestamps:timestamps,
      y: yAxisData[key],
      type: "scatter",
      mode: "lines+markers",
      name: key, // Use the key (e.g., reflux, naptha, etc.) as the label
      yaxis: index === 0 ? "y" : `y${index + 1}`, // First dataset uses `y`, others use `y2`, `y3`, etc.
    }));
  const ProjectID = sessionStorage.getItem("projectID");

  
  function downloadcsv() {
    const projectID = sessionStorage.getItem("projectID");
    const projectName = sessionStorage.getItem("projectName");

    setIsLoading(true);
    fetch(`${baseURL}/downloadtcpcsv?projectID=${projectID}`)
      .then((res) => res.json())
      .then((data) => {
        /**
        var file = new Blob([blob], {
          type: "text/csv", // Set MIME type for CSV
        });
        var url = URL.createObjectURL(file);
         */
        setGetLoader(true);
        var url = data.url;
        var link = document.createElement("a");
        link.download = projectName + "tcp" + ".csv"; // Use .csv extension
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        fetch(`${baseURL}/deletetcpcsv?projectID=${projectID}`, {
          method: "POST",
          body: JSON.stringify(projectID),
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((result) => {
            setGetLoader(false);
            setIsLoading(false);
          })
          .catch((error) => {
            console.error("Error:", error);
            setGetLoader(false);
            setIsLoading(false);
          });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setGetLoader(false);
        seterrormessage("Can't Download File");
        seterrmessage(true);
        console.log("Error", err);
      });
  }


  const cardStyle = {
    borderRadius: "22px",
    border: "1px solid #d9e9f7",
    background: "linear-gradient(to bottom,#ffffff,#fbfcff)",
    boxShadow: "0 8px 25px rgba(0,120,201,.08)",
  };

    const cardStyle2 = {
    borderRadius: "22px",
    border: "1px solid #0078C9",
    background: "linear-gradient(to bottom,#ffffff,#fbfcff)",
    boxShadow: "0 8px 25px rgba(0,120,201,.08)",
  };

  const sectionTitleStyle = {
    position: "absolute",
    top: -16,
    left: 20,
    px: 2,
    py: 0.8,
    borderRadius: "20px",
    background: "#0078c9",
    color: "#fff",
    fontWeight: 600,
    fontSize: 13,
    zIndex: 2,
  };

  const inputStyle = {
    borderRadius: "12px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#0078c9",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#9e0b22",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#0078c9",
    },
  };

  const buttonStyle = {
    width: 140,
    height: 38,
    fontSize: "12px",
    fontWeight: 600,
    borderRadius: "12px",
    color: "#fff",
    textTransform: "none",
    background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
    boxShadow: "0px 8px 18px rgba(0,120,201,.25)",
    "&:hover": {
      background: "#9e0b22",
    },
  };

  const statusPillStyle = {
    height: 36,
    px: 1.5,
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: 600,
    display: "inline-flex",
    alignItems: "center",
    border: "1px solid #d9e9f7",
    bgcolor: "#f8fbff",
  };

  return (
    <Box sx={{ mt: "1px" }}>
      <Box sx={{ display: "flex", flexDirection: "row", mt: 1  }}>
        <Paper
          elevation={0}
          sx={{
            height: 615,
            width: 1700,
            p: 2,
            display: "flex",
            flexDirection: "row",
            gap: 2,
            ...cardStyle2,
          }}
        >
          {/* LEFT MODEL FLOW AREA */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 1020,
              height: 480,
            }}
          >
            {/* DOWNLOAD */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
              <Link
                onClick={() => downloadcsv()}
                sx={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#0078c9",
                  textTransform: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.7,
                  cursor: "pointer",
                  px: 1.5,
                  py: 0.8,
                  borderRadius: "12px",
                  border: "1px solid #d9e9f7",
                  background: "#f8fbff",
                  "&:hover": {
                    color: "#9e0b22",
                    background: "#fff",
                  },
                }}
                variant="contained"
                size="large"
              >
                <img
                  alt="arrow"
                  src={Excel}
                  style={{
                    width: 26,
                    height: 26,
                  }}
                />
                Download data
              </Link>
            </Box>

            <Box
              m="auto"
              sx={{
                width: 1050,
                display: "flex",
                flexDirection: "row",
                mt: "25px",
                gap: 2,
              }}
            >
              {/* LEFT DIV */}
              <Paper
                elevation={0}
                sx={{
                  width: 245,
                  height: 330,
                  position: "relative",
                  p: 2,
                  pt: 5,
                  ...cardStyle,
                }}
              >
                <Box sx={sectionTitleStyle}>Independent Variables</Box>

                <Box
                  sx={{
                    width: "100%",
                    height: 270,
                    overflowY: "auto",
                    pr: 1,
                  }}
                >
                  {data.independent.length > 0 ? (
                    <Box>
                      <FormControl
                        sx={{
                          width: 170,
                          mb: 2,
                        }}
                        size="small"
                      >
                        <Typography sx={{ fontSize: 11, mb: 0.6 }}>
                          TimeStamp
                        </Typography>

                        <TextField
                          id="datetime-local"
                          placeholder=""
                          defaultValue={
                            data.value.length > 0 ? data.value[0] : ""
                          }
                          value={data.value.length > 0 ? data.value[0] : ""}
                          sx={{
                            width: "170px",
                            "& .MuiOutlinedInput-root": {
                              height: 36,
                              fontSize: "11px",
                              ...inputStyle,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            fontSize: "11px",
                            height: "37px",
                          }}
                        />

                        <img
                          alt="arrow"
                          src={Arrow}
                          style={{
                            width: "160px",
                            height: "28px",
                            marginTop: 4,
                          }}
                        />
                      </FormControl>

                      {data.independent.map((value, index) => (
                        <FormControl
                          key={index}
                          sx={{
                            width: 170,
                            mb: 2,
                          }}
                          size="small"
                        >
                          <Typography sx={{ fontSize: 11, mb: 0.6 }}>
                            {value}
                          </Typography>

                          <TextField
                            id="datetime-local"
                            placeholder=""
                            defaultValue={
                              data.value.length > 0 ? data.value[index + 1] : ""
                            }
                            value={
                              data.value.length > 0 ? data.value[index + 1] : ""
                            }
                            sx={{
                              width: "170px",
                              "& .MuiOutlinedInput-root": {
                                height: 36,
                                fontSize: "11px",
                                ...inputStyle,
                              },
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              fontSize: "11px",
                              height: "37px",
                            }}
                          />

                          <img
                            alt="arrow"
                            src={Arrow}
                            style={{
                              width: "160px",
                              height: "28px",
                              marginTop: 4,
                            }}
                          />
                        </FormControl>
                      ))}
                    </Box>
                  ) : (
                    <Typography sx={{ fontSize: 12, color: "#777", mt: 2 }}>
                      Waiting for Connection...
                    </Typography>
                  )}
                </Box>
              </Paper>

              {/* CENTER DIV */}
              <Box sx={{ width: 355 }}>
                <Paper
                  elevation={0}
                  sx={{
                    width: 355,
                    height: 310,
                    p: 5,
                    textAlign: "center",
                    borderRadius: "24px",
                    border: "1px solid #d9e9f7",
                    background: "linear-gradient(to bottom,#ffffff,#fbfcff)",
                    boxShadow: "0 8px 25px rgba(0,120,201,.08)",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "15px",
                      fontWeight: 700,
                      color: "#0078c9",
                    }}
                  >
                    SelexMB Trained Model
                  </Typography>

                  <img
                    alt="model"
                    src={model}
                    style={{
                      marginTop: 40,
                      objectFit: "contain",
                      height: "130px",
                    }}
                  />
                </Paper>

                <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                  {connectionClose ? (
                    <Button
                      editAccess={props.editAccess}
                      disabled={!props.editAccess}
                      onClick={() => setConnectionClose(false)}
                      sx={{ ...buttonStyle, ml: 2, mr: 2 }}
                      variant="contained"
                      size="large"
                    >
                      Start
                    </Button>
                  ) : (
                    <Button
                      editAccess={props.editAccess}
                      disabled={!props.editAccess}
                      onClick={() => setConnectionClose(true)}
                      sx={{ ...buttonStyle, ml: 2, mr: 2 }}
                      variant="contained"
                      size="large"
                    >
                      Stop
                    </Button>
                  )}

                  {connectionClose == false ? (
                    <Typography sx={{ ...statusPillStyle, color: "#1f7a1f" }}>
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          mr: 1,
                          borderRadius: "50%",
                          backgroundColor: "green",
                          animation: "blink 1s infinite",
                          "@keyframes blink": {
                            "0%": { opacity: 1 },
                            "50%": { opacity: 0.3 },
                            "100%": { opacity: 1 },
                          },
                        }}
                      />
                      Listening
                    </Typography>
                  ) : null}
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <Button
                    editAccess={props.editAccess}
                    disabled={!props.editAccess}
                    onClick={() => handleSave()}
                    sx={{ ...buttonStyle, ml: 2, mr: 2 }}
                    variant="contained"
                    size="large"
                  >
                    Save
                  </Button>

                  {saved ? (
                    <Typography sx={{ ...statusPillStyle, color: "green" }}>
                      Saved Successfully
                    </Typography>
                  ) : null}
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <Button
                    editAccess={props.editAccess}
                    disabled={!props.editAccess}
                    onClick={() => handleRefresh()}
                    sx={{ ...buttonStyle, ml: 2, mr: 2 }}
                    variant="contained"
                    size="large"
                  >
                    Restart
                  </Button>

                  {refresh ? (
                    <Typography sx={{ ...statusPillStyle, color: "green" }}>
                      Restart Successful
                    </Typography>
                  ) : null}
                </Box>
              </Box>

              {/* RIGHT DIV */}
              <Paper
                elevation={0}
                sx={{
                  width: 390,
                  height: 330,
                  position: "relative",
                  p: 2,
                  pt: 5,
                  ...cardStyle,
                }}
              >
                <Box sx={sectionTitleStyle}>Dependent Variables</Box>

                <Box
                  sx={{
                    width: "100%",
                    height: 270,
                    overflowY: "auto",
                    pr: 1,
                  }}
                >
                  {data.dependent.map((value, index) => {
                    return (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          mb: 2,
                          p: 1,
                          borderRadius: "12px",
                          "&:hover": {
                            bgcolor: "#f8fbff",
                          },
                        }}
                      >
                        <Box sx={{ width: 210 }}>
                          <Typography sx={{ fontSize: "11px", ml: 1 }}>
                            {value}
                          </Typography>

                          <img
                            alt="arrow"
                            src={Arrow}
                            style={{
                              width: "160px",
                              height: "28px",
                              marginTop: 0,
                              marginLeft: "8px",
                            }}
                          />
                        </Box>

                        <FormControl variant="outlined" size="small">
                          <OutlinedInput
                            sx={{
                              width: "135px",
                              fontSize: "11px",
                              height: "34px",
                              ...inputStyle,
                            }}
                            id="outlined-basic"
                            variant="outlined"
                            value={
                              data.value.length > 0
                                ? data.value[
                                    data.independent.length + 1 + index
                                  ]
                                : ""
                            }
                            placeholder=" "
                            size="small"
                          />
                        </FormControl>
                      </Box>
                    );
                  })}
                </Box>
              </Paper>
            </Box>
          </Box>

          {/* GRAPH PANEL */}
          <Paper
            elevation={0}
            sx={{
              mt: 0,
              mr: 2,
              width: 630,
              p: 2,
              ...cardStyle,
            }}
          >
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 700,
                color: "#0078c9",
                mb: 1,
              }}
            >
              Graph Controls
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
              <Paper
                elevation={0}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "450px",
                  p: 1.5,
                  borderRadius: "16px",
                  border: "1px solid #d9e9f7",
                  bgcolor: "#fff",
                }}
              >
                <Box sx={{ display: "inline-flex", alignItems: "center" }}>
                  <Typography sx={{ fontSize: "12px", width: 115 }}>
                    Start Timestamp:
                  </Typography>

                  <TextField
                    type="datetime-local"
                    value={startTimestamp}
                    onChange={handleStartChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: timestamps[0],
                      max: timestamps[timestamps.length - 1],
                    }}
                    variant="outlined"
                    margin="normal"
                    sx={{
                      ml: 2,
                      "& .MuiOutlinedInput-root": {
                        fontSize: "12px",
                        borderRadius: "12px",
                        ...inputStyle,
                      },
                    }}
                  />
                </Box>

                <Box sx={{ display: "inline-flex", alignItems: "center" }}>
                  <Typography sx={{ fontSize: "12px", width: 115 }}>
                    End Timestamp:
                  </Typography>

                  <TextField
                    type="datetime-local"
                    value={endTimestamp}
                    onChange={handleEndChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: timestamps[0],
                      max: timestamps[timestamps.length - 1],
                    }}
                    variant="outlined"
                    margin="normal"
                    sx={{
                      ml: 2,
                      "& .MuiOutlinedInput-root": {
                        fontSize: "12px",
                        borderRadius: "12px",
                        ...inputStyle,
                      },
                    }}
                  />
                </Box>
              </Paper>

              <Paper
                elevation={0}
                sx={{
                  width: "450px",
                  height: "160px",
                  overflowY: "auto",
                  border: "1px solid #d9e9f7",
                  borderRadius: "16px",
                  p: 1,
                  bgcolor: "#fff",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 600,
                    mb: 0.5,
                    color: "#444",
                  }}
                >
                  Select Y Axes
                </Typography>

                {Object.keys(yAxisData).map((key, i) => (
                  <FormControlLabel
                    key={key}
                    control={
                      <Checkbox
                        checked={visibleAxes[i]}
                        onChange={() => handleCheckboxChange(key, i)}
                        sx={{
                          color: "#0078c9",
                          "&.Mui-checked": {
                            color: "#9e0b22",
                            borderColor: "#0078c9",
                          },
                        }}
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: "12px" }}>{key}</Typography>
                    }
                  />
                ))}
              </Paper>
            </Box>

            <Box
              sx={{
                mt: 2,
                borderRadius: "18px",
                overflow: "hidden",
                border: "1px solid #d9e9f7",
                bgcolor: "#fff",
              }}
            >
              {Object.keys(yAxisData).length > 0 ? (
                <Plot
                  data={filteredData}
                  layout={{
                    xaxis: {
                      title: "Timestamp",
                      showgrid: true,
                      domain: [visibleAxes.filter(Boolean).length * 0.1, 1],
                      showline: true,
                      tickangle: 0,
                      tickfont: {
                        size: 10,
                      },
                      rangeslider: {
                        visible: true,
                        thickness: 0.05,
                        bordercolor: "gray",
                      },
                    },
                    yaxis: {
                      showgrid: true,
                    },

                    ...yAxisKeys
                      .filter((_, index) => visibleAxes[index])
                      .reduce((layout, key, index, array) => {
                        const axisKey =
                          index === 0 ? "yaxis" : `yaxis${index + 1}`;
                        const totalVisibleAxes = array.length;
                        const spacing = 1 / (totalVisibleAxes + 4);
                        layout[axisKey] = {
                          title: {
                            text: key,
                            standoff: 0.2,
                          },
                          anchor: "free",
                          side: "left",
                          overlaying: "y",
                          position: index * spacing,
                          tickangle: -90,
                          showline: true,
                          linecolor: "black",
                          linewidth: 1,
                          zeroline: true,
                        };
                        return layout;
                      }, {}),
                    paper_bgcolor: "#ffffff",
                    plot_bgcolor: "#f9f9f9",
                    bordercolor: "#000000",
                    borderwidth: 2,

                    legend: {
                      x: 1,
                      y: 0,
                      xanchor: "right",
                      yanchor: "bottom",
                      orientation: "v",
                    },

                    margin: {
                      l: 50,
                      r: 50,
                      t: 50,
                      b: 50,
                    },
                  }}
                  useResizeHandler={true}
                  style={{ width: "100%", height: "330px" }}
                />
              ) : (
                <Typography sx={{ fontSize: 12, p: 2 }}>
                  Loading graph...
                </Typography>
              )}
            </Box>
          </Paper>
        </Paper>
      </Box>

      {getLoader ? <GlobalLoader /> : null}
    </Box>
  );
}

export default SelexOnline;
